import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["editor", "status", "message"]
  static values = { fieldName: String }

  connect() {
    this.form = this.element.closest("form")
    this.boundSubmit = this.handleSubmit.bind(this)
    this.form?.addEventListener("submit", this.boundSubmit)
    this.check()
  }

  disconnect() {
    this.form?.removeEventListener("submit", this.boundSubmit)
  }

  check() {
    const matches = this.contactDetailTypes(this.editorTarget.value)
    const invalid = matches.length > 0
    const input = this.editorTarget.inputElement

    input?.setCustomValidity(invalid ? this.validationMessage(matches) : "")
    this.editorTarget.setAttribute("aria-invalid", invalid.toString())
    this.statusTarget.classList.toggle("hidden", !invalid)
    this.messageTarget.textContent = invalid ? this.validationMessage(matches) : ""

    return !invalid
  }

  handleSubmit(event) {
    if (this.check()) return

    event.preventDefault()
    event.stopImmediatePropagation()
    this.statusTarget.scrollIntoView({ behavior: "smooth", block: "center" })
    this.editorTarget.focus()
  }

  contactDetailTypes(html) {
    const visibleText = new DOMParser().parseFromString(html || "", "text/html").body.textContent || ""
    const content = `${visibleText} ${html || ""}`
    const matches = []

    if (/\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i.test(content)) matches.push("email address")
    if (/(?:\+44[\s().-]*(?:0[\s().-]*)?|0)(?:\d[\s().-]*){9,10}(?!\d)/.test(content)) matches.push("phone number")

    return matches
  }

  validationMessage(matches) {
    const details = matches.length === 2 ? "an email address and phone number" : `a ${matches[0]}`
    return `Remove ${details} from the ${this.fieldNameValue}. Candidates must contact you through UKCIL.`
  }
}
